/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const FacebookSquaredIcon = ({
  className,
  style,
  color = '#4867aa',
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      style={style}
      fill="none"
      height="44"
      viewBox="0 0 44 44"
      width="44"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m10 10h24v23.9999h-24z" />
      </clipPath>
      <rect fill={color} height="43.9999" rx="4" width="44" />
      <g clipPath="url(#a)">
        <path
          d="m16.3253 22.7824h2.6308v10.8305c0 .2138.1733.3871.3871.3871h4.4606c.2138 0 .3871-.1733.3871-.3871v-10.7795h3.0243c.1967 0 .3621-.1475.3846-.3429l.4593-3.9872c.0126-.1097-.0222-.2196-.0956-.3019-.0734-.0824-.1786-.1295-.2889-.1295h-3.4835v-2.4994c0-.7535.4056-1.1355 1.2058-1.1355h2.2777c.2139 0 .3871-.1734.3871-.3871v-3.6599c0-.2139-.1732-.3871-.3871-.3871h-3.1389c-.0222-.0011-.0714-.0029-.1438-.0029-.5447 0-2.4378.1069-3.9332 1.4827-1.657 1.5245-1.4266 3.3499-1.3716 3.6664v2.9227h-2.7618c-.2138 0-.3871.1733-.3871.3871v3.9363c0 .2139.1733.3872.3871.3872z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
